import { Link } from 'react-router-dom';
import {
    CardBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from 'reactstrap';
import { Card } from '../../shared/components/card/CardDashboard';

export const HomePage = () => {
    return (
        <div className='d-flex flex-wrap p-5 t-n4 py-5'>
            <h5 className='mb-0 fs-13 vh-100'>
                <div className='d-flex flex-wrap align-content-center'>
                    <h1> Dashboard Proyectos Internos</h1>
                </div>

                <CardBody className=''>
                    {/* <div className={`p-3 mt-n3 mx-n3 bg-warning-subtle rounded-top`}>
                        <div className='d-flex align-items-center'>
                            <div className='flex-grow-1'>
                                <h5 className='mb-0 fs-14'>
                                    <Link
                                        to={'/projects/project-by-id/'}
                                        className='text-dark'
                                    ></Link>
                                </h5>
                            </div>
                        </div>
                    </div> */}
                    {/* <div className='flex-shrink-0'>
                        <div className='d-flex gap-1 align-items-center my-n2'>
                            <UncontrolledDropdown direction='start'>
                                <DropdownToggle
                                    tag='button'
                                    className='btn btn-link text-muted p-1 mt-n2 py-0 text-decoration-none fs-15'
                                >
                                    <i className='ri-more-2-fill'></i>
                                </DropdownToggle>

                                <DropdownMenu className='dropdown-menu-end'>
                                    <DropdownItem href='apps-projects-overview'>
                                        <i className='ri-eye-fill align-bottom me-2 text-muted'></i>{' '}
                                        Número de Proyectos
                                    </DropdownItem>
                                    <DropdownItem href={'/projects/update-project/'}>
                                        <i className='ri-pencil-fill align-bottom me-2 text-muted'></i>{' '}
                                        Total de Proyectos Activos
                                    </DropdownItem> 
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div> */}
                    {/* <div className='d-flex   justify-content align-items-center flex- grow-2'>
                        <Card
                            title={'Total Proyectos Activos'}
                            cardUrl={'/'}
                            imageUrl={
                                '/libs/feather-icons/icons/order-approve-outline-rounded.svg'
                            }
                        />
                        <Card
                            title={'Total Proyectos Atrasados'}
                            cardUrl={'/'}
                            imageUrl={'/libs/feather-icons/icons/eyecolorgrey.svg'}
                        />
                        <Card
                            title={'Total Proyectos Atrasados/Mes'}
                            cardUrl={'/'}
                            imageUrl={
                                '/libs/feather-icons/icons/exclamation-circle 1.svg'
                            }
                        />
                        <Card
                            title={'Total Proyectos Pausados'}
                            cardUrl={'/'}
                            imageUrl={'/libs/feather-icons/icons/pause-fill.svg'}
                        />
                        <Card
                            title={'Cierre proyectos/Mes'}
                            cardUrl={'/'}
                            imageUrl={'/libs/feather-icons/icons/coin1.svg'}
                        />
                    </div> */}
                </CardBody>
            </h5>
        </div>
    );
};
